import React from 'react';

/**
 * Pola formularza podania wg schematu z API (text / textarea / number / select).
 */
export function DynamicApplicationFields({
  schemaFields,
  values,
  errors,
  onChange,
  inputClassName = '',
  disabled = false,
}) {
  if (!schemaFields || !schemaFields.length) return null;

  return schemaFields.map((f) => {
    const err = errors[f.id];
    const baseClass = [inputClassName, err ? 'error' : ''].filter(Boolean).join(' ');

    return (
      <div key={f.id} className="form-group">
        <label htmlFor={f.id}>
          {f.label}
          {f.required ? ' *' : ''}
        </label>
        {f.type === 'textarea' ? (
          <textarea
            id={f.id}
            name={f.id}
            value={values[f.id] ?? ''}
            onChange={onChange}
            rows={f.rows || 3}
            placeholder={f.placeholder || ''}
            className={baseClass}
            disabled={disabled}
          />
        ) : f.type === 'select' ? (
          <select
            id={f.id}
            name={f.id}
            value={values[f.id] ?? ''}
            onChange={onChange}
            className={baseClass}
            disabled={disabled}
            required={!!f.required}
          >
            <option value="">— wybierz —</option>
            {(f.options || []).map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        ) : (
          <input
            type={f.type === 'number' ? 'number' : 'text'}
            id={f.id}
            name={f.id}
            value={values[f.id] ?? ''}
            onChange={onChange}
            min={f.min}
            max={f.max}
            placeholder={f.placeholder || ''}
            className={baseClass}
            disabled={disabled}
          />
        )}
        {err ? <span className="error-message">{err}</span> : null}
      </div>
    );
  });
}

export function initialValuesFromSchema(schemaFields) {
  const o = {};
  if (!schemaFields) return o;
  for (const f of schemaFields) {
    o[f.id] = '';
  }
  return o;
}

export function validateClient(schemaFields, values) {
  const newErrors = {};
  if (!schemaFields) return newErrors;
  for (const f of schemaFields) {
    const raw = values[f.id];
    if (f.type === 'number') {
      if (raw === '' || raw == null) {
        if (f.required) newErrors[f.id] = 'Wymagane pole';
      } else {
        const n = Number(raw);
        if (Number.isNaN(n)) newErrors[f.id] = 'Podaj liczbę';
        else {
          const lo = f.min != null ? f.min : -Infinity;
          const hi = f.max != null ? f.max : Infinity;
          if (n < lo || n > hi) newErrors[f.id] = `Wartość musi być ${lo}–${hi}`;
        }
      }
    } else if (f.type === 'select') {
      if (f.required && !String(raw || '').trim()) newErrors[f.id] = 'Wybierz opcję';
    } else {
      if (f.required && !String(raw || '').trim()) newErrors[f.id] = 'Wymagane pole';
    }
  }
  return newErrors;
}

/** Odpowiedzi do API: liczby jako number */
export function buildResponsesPayload(schemaFields, values) {
  const out = {};
  for (const f of schemaFields) {
    const raw = values[f.id];
    if (f.type === 'number') {
      if (raw === '' || raw == null) continue;
      out[f.id] = parseInt(String(raw), 10);
    } else {
      const s = String(raw ?? '').trim();
      if (!s && !f.required) continue;
      out[f.id] = s;
    }
  }
  return out;
}

export function valuesFromApplicationRow(app) {
  const snap = app?.form_schema_snapshot;
  const fields = snap?.fields;
  const out = {};
  if (!fields) return out;
  const r = app.responses && typeof app.responses === 'object' ? app.responses : {};
  for (const f of fields) {
    let v = r[f.id];
    if (v === undefined || v === null) v = app[f.id];
    out[f.id] = v != null ? String(v) : '';
  }
  return out;
}
